<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi">
<p class="epigraphPage"><span class="xrefInternal"><a href="#/pinkpantherthe#epi_01"><span class="bold">Epigraph</span></a></span></p>
<p class="epigraphText">“Comedy is a man in trouble.”</p>
<p class="epigraphSource">J<span class="smallCaps">OSEPH</span> L<span class="smallCaps">EVITCH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?588e6e06